import {
  Box,
  ColumnLayout,
  Container,
  Header,
  SpaceBetween,
} from '@amzn/awsui-components-react';

const ValueWithLabel = ({ label, children }) => (
    <div>
      <Box margin={{ bottom: 'xxxs' }} color="text-label">
        {label}
      </Box>
      <div>{children}</div>
    </div>
);

const AccountDetails = (props) => {
    return (
      <Container header={<Header variant="h2">Account Details</Header>}>
          <ColumnLayout columns={4} variant="text-grid">
              <SpaceBetween size="l">
                  <ValueWithLabel label="SkyCrane Cell Name">
                      {props.CPCellName
                          ? props.CPCellName.getCPCellName
                          : '--'}
                  </ValueWithLabel>
              </SpaceBetween>
              <SpaceBetween size="l">
                  <ValueWithLabel label="Data Plane Cell Name">
                      {props.DPCellName
                          ? props.DPCellName.getDPCellName
                          : '--'}
                  </ValueWithLabel>
              </SpaceBetween>
              <SpaceBetween size="l">
                  <ValueWithLabel label="Search OCUs (Non CollectionGroup)">
                      {props.searchOCUsCount
                          ? props.searchOCUsCount
                          : '--'}
                  </ValueWithLabel>
              </SpaceBetween>
              <SpaceBetween size="l">
                  <ValueWithLabel label="Indexing OCUs (Non CollectionGroup)">
                      {props.indexingOCUsCount
                          ? props.indexingOCUsCount
                          : '--'}
                  </ValueWithLabel>
              </SpaceBetween>
              <SpaceBetween size="l">
                  <ValueWithLabel label="Number of Collections">
                      {props.accountCollectionsCount
                          ? props.accountCollectionsCount
                          : '--'}
                  </ValueWithLabel>
              </SpaceBetween>
              <SpaceBetween size="l"></SpaceBetween>
              <SpaceBetween size="l">
                  <ValueWithLabel label="Max SearchOCUs (Non CollectionGroup)">
                      {props.maxSearchOCUs
                          ? props.maxSearchOCUs
                          : '--'}
                  </ValueWithLabel>
              </SpaceBetween>
              <SpaceBetween size="l">
                  <ValueWithLabel label="Max IndexingOCUs (Non CollectionGroup)">
                      {props.maxIndexingOCUs
                          ? props.maxIndexingOCUs
                          : '--'}
                  </ValueWithLabel>
              </SpaceBetween>
          </ColumnLayout>
      </Container>
  );
};

export { AccountDetails };
